module.exports = __webpack_public_path__ + "img/background-menu-profile.64bc3c7f.svg";